import { useQuery } from '@tanstack/react-query'
import { profile, isEmpty } from '@myap/ui-library'
import { getRequest, queryIsEnabled } from '../utils/fetchOperations'
import fetchSchoolsByDICode from '../requests/fetchSchoolsByDICode'
import { SCORE_SEND_KEY } from '../components/_common/reactquery'
import { USER_PROMPT_MODAL_UPDATE } from '../components/scoresend/constants'

const useStudentScoreSendQuery = ({ educationPeriodCd, studentId, hasEnrollments }) => {
  const { apiUrl } = profile()
  return useQuery({
    queryKey: [SCORE_SEND_KEY, educationPeriodCd, studentId],
    // staleTime: 3600000,
    staleTime: 1000,
    refetchOnWindowFocus: false,
    enabled: queryIsEnabled(!isEmpty(educationPeriodCd) && !isEmpty(studentId) && hasEnrollments),
    queryFn: async ({ signal }) => {
      const scoreSendData = await getRequest({
        url: `${apiUrl}/score-send-di/education-period-cd/${educationPeriodCd}/studentId/${studentId}`,
        signal,
      })
      const { diCode } = scoreSendData
      const diInfo = diCode ? await fetchSchoolsByDICode(diCode, 10) : null
      // There is a diCode, but the selected org is not active
      if (diCode && !diInfo?.suggestions[0]?.activeInd) {
        return {
          ...scoreSendData,
          userPromptType: USER_PROMPT_MODAL_UPDATE,
          diCode: null, // clear the diCode as user needs to provide new code
          org: diInfo.suggestions[0],
        }
      }
      return diInfo ? { ...scoreSendData, org: diInfo.suggestions[0] } : scoreSendData
    },
  })
}

export default useStudentScoreSendQuery
